export default __webpack_public_path__ + "img/d6da6ca42ac4bce111ef1e379778e050.png";